// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Your love, O Lord, reaches to the heavens&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and your faithfulness to the clouds.<br> </p> </div></div>";
// Exports
module.exports = code;